module.exports = __webpack_public_path__ + "img/iap-formation.bb558cd3.gif";